// Dati aziendali centrali EDIL CIMA S.R.L. — utilizzati in SEO, JSON-LD, footer, contatti
export const COMPANY = {
  legalName: 'EDIL CIMA S.R.L.',
  brand: 'EDIL CIMA',
  vat: '04778580987',
  fiscalCode: '04778580987',
  sdiCode: 'M5UXCR1',
  pec: 'edilcimasrl@pecaruba.it',
  email: 'info@edilcima.it',
  phoneFisso: '+39 030 9985813',
  phoneGermano: '+39 338 693 7214',
  phoneSimone: '+39 334 367 8791',
  address: {
    street: 'Via XX Settembre 22',
    city: 'Calcinato',
    province: 'BS',
    region: 'Lombardia',
    cap: '25011',
    country: 'IT',
    lat: 45.4543,
    lng: 10.4117,
  },
  hours: 'Lun–Ven 7:00–19:00',
  hoursSpec: ['Mo-Fr 07:00-19:00'],
  foundingYear: 2000,
  website: 'https://edilcima.it',
  legacyWebsite: 'https://impresaedilecima.it',
  founder: 'Germano Cima',
  team: ['Germano Cima', 'Simone Cima'],
  servicesAreas: [
    'Calcinato', 'Brescia', 'Montichiari', 'Lonato del Garda', 'Desenzano del Garda',
    'Rezzato', 'Mazzano', 'Bedizzole', 'Castenedolo', 'Carpenedolo', 'Ghedi',
    'Salò', 'Sirmione', 'Manerba del Garda', 'Padenghe sul Garda',
  ],
};

export const SERVICES = [
  {
    id: 'nuove-costruzioni',
    name: 'Nuove Costruzioni',
    short: 'Edifici residenziali e commerciali chiavi in mano.',
    description: 'Costruiamo case unifamiliari, ville, palazzine e edifici commerciali dalle fondamenta alle finiture. Direzione lavori interna, materiali certificati, rispetto delle tempistiche.',
    image: 'https://impresaedilecima.it/wp-content/uploads/2023/10/nuove.jpg',
    bullets: ['Progettazione esecutiva', 'Strutture in c.a. e muratura', 'Finiture personalizzate', 'Pratiche edilizie'],
  },
  {
    id: 'ristrutturazioni',
    name: 'Ristrutturazioni',
    short: 'Trasformiamo appartamenti e locali commerciali.',
    description: 'Ristrutturazione completa o parziale di appartamenti, ville e locali commerciali. Demolizioni, nuovi impianti, finiture, posa pavimenti e rivestimenti. Gestione bonus fiscali.',
    image: 'https://impresaedilecima.it/wp-content/uploads/2023/10/ristrutturazioni.jpg',
    bullets: ['Bagni e cucine chiavi in mano', 'Impianti elettrici e idraulici', 'Cartongesso e finiture', 'Gestione pratiche bonus'],
  },
  {
    id: 'rifacimento-tetti',
    name: 'Rifacimento Tetti',
    short: 'Coperture sicure, isolate ed eleganti.',
    description: 'Sostituzione integrale o parziale di coperture, isolamento termico (cappotto in copertura), guaine impermeabilizzanti, lattoneria, lucernari. Garanzie sui materiali.',
    image: 'https://impresaedilecima.it/wp-content/uploads/2023/10/tetti.jpg',
    bullets: ['Tetti ventilati', 'Isolamento termico', 'Lattoneria e gronde', 'Lucernari Velux'],
  },
  {
    id: 'piscine',
    name: 'Realizzazione Piscine',
    short: 'Piscine interrate su misura per il tuo giardino.',
    description: 'Realizzazione piscine interrate in cemento armato, gelcoat o liner. Progettazione idraulica, impianti di filtrazione, illuminazione subacquea, pavimentazione bordo piscina.',
    image: 'https://impresaedilecima.it/wp-content/uploads/2023/10/piscine.jpg',
    bullets: ['Piscine in c.a.', 'Impianti di filtrazione', 'Bordo piscina e solarium', 'Manutenzione stagionale'],
  },
  {
    id: 'manutenzioni',
    name: 'Manutenzioni',
    short: 'Interventi rapidi per case, hotel e condomini.',
    description: 'Servizio manutenzione programmata e di urgenza per abitazioni private, condomini, hotel e attività ricettive. Idraulica, elettricità, muratura, tinteggiatura.',
    image: 'https://impresaedilecima.it/wp-content/uploads/2023/10/manutenzioin.jpg',
    bullets: ['Pronto intervento', 'Contratti annuali condomini', 'Lavori per hotel', 'Piccoli lavori edili'],
  },
];

export const FAQS = [
  {
    q: 'Dove ha sede EDIL CIMA S.R.L. e in quali zone lavorate?',
    a: 'EDIL CIMA S.R.L. ha sede a Calcinato (Brescia), in Via XX Settembre 22. Operiamo in tutta la provincia di Brescia e nelle zone limitrofe della Lombardia, incluso il lago di Garda (Desenzano, Sirmione, Salò, Manerba), Montichiari, Ghedi, Lonato, Rezzato, Mazzano, Bedizzole.',
  },
  {
    q: 'Da quanti anni siete attivi nel settore edile?',
    a: 'EDIL CIMA è attiva dai primi anni 2000, fondata da Germano Cima sulla base di una vasta esperienza sul campo. Dal 2021 il figlio Simone è entrato in società, garantendo continuità generazionale e competenze aggiornate.',
  },
  {
    q: 'Quali servizi offrite?',
    a: 'Offriamo nuove costruzioni residenziali e commerciali, ristrutturazioni complete di appartamenti e locali, rifacimento tetti con isolamento termico, realizzazione piscine interrate, e manutenzioni ordinarie e straordinarie per privati, condomini e strutture ricettive. Eseguiamo anche impianti elettrici, idraulici, cartongesso, posa pavimenti e finiture personalizzate.',
  },
  {
    q: 'Il preventivo è gratuito?',
    a: 'Sì, il sopralluogo e il preventivo dettagliato sono sempre gratuiti e senza impegno. Forniamo computi metrici trasparenti basati sul Prezzario CER Brescia 2025, con voci chiare per materiali, manodopera e tempistiche.',
  },
  {
    q: 'Lavorate con i bonus fiscali (Bonus Ristrutturazioni, Ecobonus, Bonus Casa)?',
    a: 'Sì, gestiamo cantieri compatibili con i principali bonus edilizi vigenti (Bonus Ristrutturazioni 50%, Ecobonus, Bonus Casa). Forniamo tutta la documentazione tecnica e fiscale necessaria per la detrazione.',
  },
  {
    q: 'I lavori sono certificati e garantiti?',
    a: 'Tutti i nostri lavori sono certificati e seguiti da professionisti del settore. Forniamo dichiarazioni di conformità degli impianti, garanzie sui materiali e sulle lavorazioni a regola d\'arte.',
  },
  {
    q: 'Come posso contattarvi?',
    a: 'Puoi chiamarci al 030 9985813 (ufficio) oppure direttamente Germano al 338 693 7214 o Simone al 334 367 8791. Per richieste scritte, scrivici all\'email info@edilcima.it o alla PEC edilcimasrl@pecaruba.it. Siamo operativi dal lunedì al venerdì, dalle 7:00 alle 19:00.',
  },
  {
    q: 'Realizzate anche piscine personalizzate?',
    a: 'Sì, realizziamo piscine interrate in cemento armato su misura, complete di impianti di filtrazione, illuminazione subacquea, sistemazione del bordo piscina e dell\'area solarium. Offriamo anche manutenzione stagionale.',
  },
];

// JSON-LD Schema.org per Local Business / General Contractor — critico per GEO
export const jsonLdLocalBusiness = {
  '@context': 'https://schema.org',
  '@type': 'GeneralContractor',
  '@id': `${COMPANY.website}/#organization`,
  name: COMPANY.legalName,
  alternateName: ['Edil Cima', 'Impresa Edile Cima', 'Cima Germano'],
  url: COMPANY.website,
  logo: `${COMPANY.website}/edilcima_logo.png`,
  image: 'https://impresaedilecima.it/wp-content/uploads/2023/10/IMG_4196.jpg',
  description: 'Impresa edile a Calcinato (Brescia) specializzata in nuove costruzioni, ristrutturazioni, rifacimento tetti, realizzazione piscine e manutenzioni. Attiva dal 2000.',
  foundingDate: '2000',
  founder: { '@type': 'Person', name: COMPANY.founder },
  vatID: COMPANY.vat,
  taxID: COMPANY.fiscalCode,
  telephone: COMPANY.phoneFisso,
  email: COMPANY.email,
  address: {
    '@type': 'PostalAddress',
    streetAddress: COMPANY.address.street,
    addressLocality: COMPANY.address.city,
    addressRegion: COMPANY.address.province,
    postalCode: COMPANY.address.cap,
    addressCountry: COMPANY.address.country,
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: COMPANY.address.lat,
    longitude: COMPANY.address.lng,
  },
  openingHoursSpecification: [{
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
    opens: '07:00',
    closes: '19:00',
  }],
  areaServed: COMPANY.servicesAreas.map(n => ({ '@type': 'City', name: n })),
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Servizi edili',
    itemListElement: SERVICES.map(s => ({
      '@type': 'Offer',
      itemOffered: { '@type': 'Service', name: s.name, description: s.description },
    })),
  },
  contactPoint: [
    { '@type': 'ContactPoint', telephone: COMPANY.phoneFisso, contactType: 'customer service', availableLanguage: 'Italian', areaServed: 'IT' },
    { '@type': 'ContactPoint', telephone: COMPANY.phoneGermano, contactType: 'sales', name: 'Germano Cima', availableLanguage: 'Italian' },
    { '@type': 'ContactPoint', telephone: COMPANY.phoneSimone, contactType: 'sales', name: 'Simone Cima', availableLanguage: 'Italian' },
  ],
  sameAs: [COMPANY.legacyWebsite],
};

export const jsonLdFAQ = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQS.map(f => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export const jsonLdBreadcrumb = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: COMPANY.website },
    { '@type': 'ListItem', position: 2, name: 'Servizi Edili', item: `${COMPANY.website}#servizi` },
    { '@type': 'ListItem', position: 3, name: `Calcinato (${COMPANY.address.province})`, item: `${COMPANY.website}#contatti` },
  ],
};

// ItemList di servizi - rich result "Lista" che Google puo' mostrare come
// risultato espanso nella SERP con i singoli servizi (boost CTR).
export const jsonLdServicesItemList = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'Servizi EDIL CIMA S.R.L.',
  description: 'Servizi edili offerti da EDIL CIMA S.R.L. a Calcinato (Brescia) e provincia.',
  itemListOrder: 'https://schema.org/ItemListOrderAscending',
  numberOfItems: SERVICES.length,
  itemListElement: SERVICES.map((s, idx) => ({
    '@type': 'ListItem',
    position: idx + 1,
    item: {
      '@type': 'Service',
      '@id': `${COMPANY.website}#service-${s.id}`,
      name: s.name,
      description: s.description,
      image: s.image,
      url: `${COMPANY.website}#${s.id}`,
      provider: { '@id': `${COMPANY.website}/#organization` },
      areaServed: COMPANY.servicesAreas.map(n => ({ '@type': 'City', name: n })),
      serviceType: s.name,
    },
  })),
};
